window.onload = (event) => {

//Extra options wrap in new div
const observer = new MutationObserver(() => {
  const radios = document.querySelectorAll('input[type="radio"][name="extra-options"]');

  if (radios.length > 0) {
    radios.forEach(radio => {
      const label = document.querySelector(`label[for="${radio.id}"]`);

      if (label && !label.dataset.bound) {
        label.addEventListener('click', function () {
          const firstExtraOption = document.querySelector('.extra-options');
          if (firstExtraOption) {
            const parent = firstExtraOption.parentElement;
            const extraOptions = parent.querySelectorAll('.extra-options');

            // Avoid creating multiple wrappers
            if (!parent.querySelector('.extra-options-wrapper')) {
              const wrapper = document.createElement('div');
              wrapper.classList.add('extra-options-wrapper');
              wrapper.style.display = 'flex';
              wrapper.style.flexWrap = 'wrap';
              wrapper.style.gap = '8px';
              
              extraOptions.forEach(option => {            
                option.style.boxSizing = 'border-box';
                option.style.width = '93px';
                wrapper.appendChild(option);
                  // Move .gpo-label.expanded inside each .extra-options, below .gpo-ov-wrapper
                  const labelToMove = option.querySelector('.gpo-label.expanded');
                  const ovWrapper = option.querySelector('.gpo-ov-wrapper');
                
                  if (labelToMove && ovWrapper && !labelToMove.dataset.moved) {
                    ovWrapper.insertAdjacentElement('afterend', labelToMove);
                    labelToMove.dataset.moved = 'true'; // Prevent re-move
                  }
              });

              parent.appendChild(wrapper);
            }

            // Move .gpo-total to the end of parent
            const gpoTotal = parent.querySelector('.gpo-total');
            if (gpoTotal) {
              parent.appendChild(gpoTotal);
            }
          }
        });

        // Prevent re-binding the event
        label.dataset.bound = 'true';
      }
    });

    // Stop observing once radios are found and processed
    observer.disconnect();
  }
});

// Start observing the body for dynamic content
observer.observe(document.body, { childList: true, subtree: true });



//Product Image Slider
$(document).ready(function () {
  $('.main-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    infinite: true,
    adaptiveHeight: true
  });

    $('.thumb-slider').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.main-slider',
    dots: false,
    centerMode: false,
    focusOnSelect: true,
    arrows: true,
    adaptiveHeight: true
  });

  $('.thumb-item').on('click', function () {
  const index = $(this).data('index');
  $('.main-slider').slick('slickGoTo', index);

      // Optional: Active class for selected thumb
    $('.thumb-item').removeClass('active-thumb');
    $(this).addClass('active-thumb');
  });
});
}



//Reviews section
document.addEventListener("DOMContentLoaded", function () {
  // Review section scroll top after submission
    const headerElement = document.querySelector('.jdgm-rev-widg__header');
    if (!headerElement) return;

    // Observe DOM for the dynamically inserted submit button
    const observer = new MutationObserver(function (mutations, observer) {
        const submitButton = document.querySelector('.jdgm-submit-rev');

        if (submitButton) {
            // Attach click handler once button is found
            submitButton.addEventListener('click', function () {
                // Watch for success notification after click
                const notifyObserver = new MutationObserver((mutationsList, notifyObserver) => {
                    const notification = document.querySelector('.jdgm-notification');
                    if (notification && notification.offsetParent !== null) {
                        const offset = 100;
                        const topPos = headerElement.getBoundingClientRect().top + window.pageYOffset - offset;
                        window.scrollTo({ top: topPos, behavior: 'smooth' });
                        notifyObserver.disconnect();
                    }
                });

                notifyObserver.observe(document.body, { childList: true, subtree: true });
            });

            observer.disconnect(); // Stop looking once button is found
        }
    });

    // Start observing the body for changes
    observer.observe(document.body, { childList: true, subtree: true });

  
//Hide extra options based on radio toggle
const observer2 = new MutationObserver(function (mutations, observer2) {
  const radioGroups = {
    breath: '#image-swatches-7_1',
    heating: 'heating',
    metabox: 'metabox',
    vibratechest: 'vibratechest',
    'lube-free-vag': 'lube-free-vag'
  };

  const targets = {
    evo:'image-swatches-6_1',
    breath: 'image-swatches-6',
    heating: ['image-swatches-6', 'image-swatches-7'],
    metabox: ['image-swatches-7','image-swatches-8'],
    vibratechest: 'image-swatches-8',
    'lube-free-vag': 'image-swatches-9'
  };

  const isAllPresent = Object.keys(radioGroups).every((name) => {
    return document.querySelectorAll(`input[name="${name}"]`).length;
  });

  if (isAllPresent) {
    Object.entries(radioGroups).forEach(([groupName, identifier]) => {
      const radios = document.querySelectorAll(`input[name="${groupName}"]`);

      radios.forEach((radio) => {
        radio.addEventListener('change', () => {
           const extraNo = document.querySelector('#buttons-2_2');
          // Special handling for 'breath'
          if (groupName === 'breath') {
            const yesRadio = document.querySelector('#image-swatches-7_1');
            const targetDiv = document.querySelector('div[data-element-id="image-swatches-6"]');
            if (yesRadio?.checked) {
              targetDiv?.setAttribute('data-clo-display', 'show');
            } else if(extraNo?.checked){
              targetDiv?.setAttribute('data-clo-display', 'show');
            }
            else {
              targetDiv?.setAttribute('data-clo-display', 'hide');
            }
            return;
          }

          // For other groups: hide targets when a radio is selected, show when none selected
          const hideTargets = Array.isArray(targets[groupName]) ? targets[groupName] : [targets[groupName]];
          const selected = [...radios].some(r => r.checked && r.value !== '');

          hideTargets.forEach((targetId) => {
            const targetEl = document.querySelector(`div[data-element-id="${targetId}"]`);
           
            if (targetEl) {
              if (selected) {
                targetEl.setAttribute('data-clo-display', 'show');
              }
              else if(extraNo?.checked){
                targetEl.setAttribute('data-clo-display', 'show');
              }
              else {
                targetEl.setAttribute('data-clo-display', 'hide');
              }
            }
          });
        });
      });
    });

    observer2.disconnect();
  }
});

observer2.observe(document.body, { childList: true, subtree: true });


  document.querySelectorAll('.product__modal-opener .zoom-section').forEach(section => {
    section.addEventListener('click', (e) => {
      e.preventDefault();

      // Find and click the native Shopify button to trigger default modal behavior
      const toggleButton = section.closest('modal-opener')?.querySelector('.product__media-toggle');
      if (toggleButton) {
        toggleButton.click(); // This ensures correct image, scroll, modal behavior
      }
    });
  });
  
});

